import Routes from '../consts/routes';

export const httpError5XXCodes = new Set([500, 501, 502, 503, 504, 505, 506, 507, 509, 510]);

export function redirectToError5xxPage() {
  window.location.href = Routes.Error5XX(window.location.pathname);
}
